import React, { useState, useRef, useEffect } from 'react';
import SearchBar from './SearchBarF/SearchBar';
import SearchResults from './SearchResults/SearchResults'

export default function Search (props) {
    
    const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
    const [stickyWidth, setStickyWidth] = useState();
    const headerRef = useRef(null);

    // handle scroll event
    const handleScroll = (elTopOffset, elHeight, elWidth) => {
        if (window.pageYOffset > (elTopOffset + elHeight)) {
            setSticky({ isSticky: true, offset: elHeight });
            setStickyWidth(elWidth)
        } else {
            setSticky({ isSticky: false, offset: 0 });
        }
    };

    // add/remove scroll event listener
    useEffect(() => {
        var header = headerRef.current.getBoundingClientRect();
        const handleScrollEvent = () => {
            handleScroll(header.top, header.height, header.width)
        }

        window.addEventListener('scroll', handleScrollEvent);

        return () => {
            window.removeEventListener('scroll', handleScrollEvent);
        };
    }, []);

    function pluralise(string, qty){
        return qty + ' ' + string + (qty === 1 ? '' : 's');
    }

    function children(qty) {
        return qty === 0 ? '' : (qty === 1 ? ' 1 child' : (' ' + qty + ' children'));
    }

    function getPromptText() {

        var roomsCount = props.reservation.selectedRooms.length;
        var roomsSelected = props.reservation.selectedRooms.filter(room => room.roomType !== undefined).length;
        var currentRoom = props.reservation.selectedRooms.find(room => room.roomType === undefined);

        var occupants = ' for ' + pluralise('adult',currentRoom.adults) + children(currentRoom.children);
        
        switch (true) {
            case roomsCount === 1 && roomsSelected === 0:
                return "Select your room" + occupants;
                break;
            case roomsCount > 1 && roomsSelected < roomsCount:
                return "Select your " + nth(roomsSelected) + " room" + occupants;
                break;
            
        }
        
    }

    

    function nth(i) {

        var ordinals = [
            'first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelfth', 'thirteen', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth', 'eighteenth', 'nineteenth', 'twentieth'];

        return ordinals[i];

    }

    
            return (
        <div style={{ marginTop: sticky.offset }}>
                                
            <div className='rates-and-availability-container'>

                <div className='header'>
                    <SearchBar
                        reservation={props.reservation}
                        checkIn={props.reservation.checkIn}
                        checkOut={props.reservation.checkOut}
                        roomTypes={props.roomTypes}
                        search={props.search}
                        propertyId={props.propertyId}
                        promotions={props.promotions}
                        mode={props.mode}
                        changeAdults={props.changeAdults}
                        changeChildren={props.changeChildren}
                        showDatePicker={props.showDatePicker}
                        changeDates={props.changeDates}
                        closedDates={props.closedDates}
                    />

                </div>
                    
                <div className={sticky.isSticky ? 'sticky' : ''} style={{ marginTop: 10, zIndex: 100 }} ref={headerRef}>
                    <div class="clearfix">
                        
                        <p className='bg-warning float-right prompt' >{ getPromptText()}</p>
                    </div>
                     
                </div>
                                
                <div>
                    <SearchResults
                        propertyId={props.propertyId}
                        propertyKey={props.propertyKey}
                        checkIn={props.reservation.checkIn}
                        checkOut={props.reservation.checkOut}
                        nights={props.reservation.nights}
                        adults={props.reservation.selectedRooms.find(room => room.roomType === undefined).adults}
                        children={props.reservation.selectedRooms.find(room => room.roomType === undefined).children}
                        promoCode={props.reservation.promoCode}
                        select={props.select}
                        rooms={props.reservation.selectedRooms}
                        roomTypes={props.roomTypes}
                        selectedRooms={props.reservation.selectedRooms}
                        mode={props.mode}
                    />

                </div>

            </div>
        </div>
    );
    

    
}
